module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Video-camera-1eba2a188cf3b9b08134fca28d56bdcb.svg";